/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * UserGamesBase
 * auto generated base class for the model UserGamesModel.
 */
export const UserGamesModelBase = ModelBase.named('UserGames')
  .props({
    __typename: types.optional(types.literal('UserGames'), 'UserGames'),
    createdAt: types.union(types.undefined, types.frozen()),
    gameId: types.union(types.undefined, types.string),
    hash: types.union(types.undefined, types.string),
    numberOfHands: types.union(types.undefined, types.number),
    numberOfHandsPlayed: types.union(types.undefined, types.number),
    numberOfHandsWon: types.union(types.undefined, types.number),
    timePlayed: types.union(types.undefined, types.number)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class UserGamesModelSelector extends QueryBuilder {
  get createdAt() {
    return this.__attr('createdAt')
  }
  get gameId() {
    return this.__attr('gameId')
  }
  get hash() {
    return this.__attr('hash')
  }
  get numberOfHands() {
    return this.__attr('numberOfHands')
  }
  get numberOfHandsPlayed() {
    return this.__attr('numberOfHandsPlayed')
  }
  get numberOfHandsWon() {
    return this.__attr('numberOfHandsWon')
  }
  get timePlayed() {
    return this.__attr('timePlayed')
  }
}
export function selectFromUserGames() {
  return new UserGamesModelSelector()
}

export const userGamesModelPrimitives =
  selectFromUserGames().createdAt.gameId.hash.numberOfHands.numberOfHandsPlayed.numberOfHandsWon.timePlayed
